import React, { useEffect, useState } from 'react'
import SkuItem from '../../CollectionDetail/view/components/SkuItem'
import Detail from './components/Detail'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import apiUrl from '@common/utils/apiURL';
import useApi from '@common/utils/useApi';
import axios from 'axios';
import axiosInstance from '@common/utils/axiosInstance';
import SeoContainer from '@common/components/SeoContainer';

function SkuDetail() {
    const { slug } = useParams(); // Get the dynamic id from the route
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const collectionId = searchParams.get("collectionId");
    const [collectionData, setCollectionData] = useState(JSON.parse(localStorage["collection-data"] || null));
    const [materialData, setMaterialData] = useState([])
    const [remainingMaterialData, setRemainingMaterialData] = useState([])
    const [seoData, setSeoData] = useState(null);

    console.log({ collectionData, materialData, remainingMaterialData });

    useEffect(() => {
        const fetchCollectionData = async () => {
            try {
                const materialsBySlugUrl = apiUrl.collection.getMaterialsBySlug(slug);
                if (!materialsBySlugUrl) return;

                const response = await axiosInstance.get(materialsBySlugUrl);
                if (response.status === 200) {
                    const collectionId = response.data?.collectionId;
                    if (!collectionId) return;

                    const materialsByIdUrl = apiUrl.collection.getMaterialsById(collectionId);
                    if (!materialsByIdUrl) return;

                    const collectionResponse = await axiosInstance.get(materialsByIdUrl);
                    if (collectionResponse.status === 200) {
                        localStorage["collection-data"] = JSON.stringify(collectionResponse.data);
                        setCollectionData(collectionResponse.data);
                    } else {
                        console.error('Error fetching collection data');
                    }
                } else {
                    console.error('Error fetching material by slug');
                }
            } catch (error) {
                console.error('Error in fetchCollectionData:', error);
            }
        };

        fetchCollectionData();
    }, [slug]);

    useEffect(() => {
        if (!collectionData) return;

        const filteredMaterialData = collectionData?.MaterialDetails?.filter(item => {
            console.log('Comparing item.slug:', item?.slug, 'with slug:', slug, '=>', item?.slug === slug);
            return item?.slug === slug;
        }) || [];
        console.log({ filteredMaterialData });
        setMaterialData(filteredMaterialData);

        const filteredRemainingMaterialData = collectionData?.MaterialDetails?.filter(
            item => item.qualityId === filteredMaterialData[0]?.qualityId
        ) || [];
        setRemainingMaterialData(filteredRemainingMaterialData);

        if (filteredMaterialData[0]) {
            setSeoData({
                pageTitle: `${filteredMaterialData[0]?.endUse}-${filteredMaterialData[0]?.designType}-${filteredMaterialData[0]?.colorFamily}`,
                metaDescription: `${filteredMaterialData[0]?.endUse}-${filteredMaterialData[0]?.designType}-${filteredMaterialData[0]?.colorFamily}-${filteredMaterialData[0]?.productCategoryCollectionBase}`,
                metaKeywords: '',
                canonical: window.location.href
            });
        }
    }, [collectionData, slug]);

    const scrollTopHandleChange = () => {
        window.scrollTo(0, 0);
    }

    return (
        <>
            <SeoContainer {...seoData} />
            <div className='bs-section bs-section--typ-grey cm-no-padding lyt-details'>
                <div className="lyt-details__action">
                    <button className="bs-btn bs-btn__btn-icon-link" onClick={() => navigate(-1)}>
                        <span className='bs-btn__icon icon icon-back'></span>
                        <span className='bs-btn__btn-text'>Back</span>
                    </button>
                </div>
                <div className='bs-section__section-cont'>
                    <Detail data={collectionData} materialData={materialData[0]} />
                </div>
            </div>
            <div className='bs-section'>
                <div className='bs-section__section-cont'>
                    <div className='lyt-product'>
                        <div className='lyt-product__title-wrap'>
                            <h2 className='lyt-product__title'>All Colours</h2>
                        </div>
                        <ul className='lyt-product__list-wrap'>
                            {remainingMaterialData.map((item, index) => {
                                if (item?.materialCode !== materialData[0]?.materialCode) {
                                    return (
                                        <li className='lyt-product__list-item' key={index} onClick={scrollTopHandleChange}>
                                            <SkuItem
                                                imageId={item.skuImageUrl}
                                                link={`/sku-detail/${item?.slug}`}
                                                title={collectionData?.name + ", Sr.No. " + item.serialNo}
                                            />
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SkuDetail